import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { DxcBrandComponent } from './dxc-brand.component';

/** Duración de la salida — tiene que coincidir con `dxc-splash-out` en `_components.scss`. */
export const DXC_SPLASH_LEAVE_MS = 320;

/**
 * La única pantalla de carga del arranque.
 *
 * Antes había dos superpuestas al refrescar: el lienzo blanco con el logo en
 * PNG y, encima, el velo desenfocado del cargador global que abría la propia
 * vista. Dos capas para un solo hecho — la aplicación todavía no está lista.
 */
@Component({
    standalone: true,
    selector: 'dxc-splash',
    templateUrl: './dxc-splash.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [DxcBrandComponent],
})
export class DxcSplashComponent {

    /** Fija a la ventana. Se apaga solo para mostrarlo dentro del catálogo. */
    @Input() full = true;
    /** Alto del símbolo; el resto de la marca se deriva de él. */
    @Input() size = 38;
    /** Una línea bajo la marca. Vacía si no hay nada que decir. */
    @Input() hint = 'Preparando tu operación…';
    /** Dispara la salida. Quien lo pone tiene que quitar el componente al terminar. */
    @Input() leaving = false;
}
